import { render, staticRenderFns } from "./ItemDetailRecentlyViewed.vue?vue&type=template&id=53f51cfc&"
import script from "./ItemDetailRecentlyViewed.vue?vue&type=script&lang=ts&"
export * from "./ItemDetailRecentlyViewed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports